import { TrpcProvider, api } from './lib/react';

export { TrpcProvider, api };
